export const SET_LOADING_DATA = '@loadControl/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@loadControl/SET_LOADING_SEND';

export const GET_ALL_REQUEST = '@loadControl/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@loadControl/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@loadControl/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@loadControl/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@loadControl/SAVE_REQUEST';
export const SAVE_SUCCESS = '@loadControl/SAVE_SUCCESS';

export const CANCEL_REQUEST = '@loadControl/CANCEL_REQUEST';
export const CANCEL_SUCCESS = '@loadControl/CANCEL_SUCCESS';

export const DELETE_ITEM = '@loadControl/DELETE_ITEM';
export const EDIT_ITEM = '@loadControl/EDIT_ITEM';

export const VIEW_ITEM = '@loadControl/VIEW_ITEM';

export const SEARCH = '@loadControl/SEARCH';

export const SET_PAGE = '@loadControl/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@loadControl/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@loadControl/SET_ORDER';
export const SET_ORDERBY = '@loadControl/SET_ORDEBY';
